import React from "react";
import { ArcBox, ArcButton } from "@src/core/ui";
import { OrderStatusEnum } from "@src/features/order/entities";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

interface ViewAllButtonProps {
  onClick: () => void;
  status?: OrderStatusEnum;
}

const ViewAllButton: React.FC<ViewAllButtonProps> = (props) => {
  const { onClick } = props;

  return (
    <ArcBox
      sx={{
        alignItems: "center",
        height: "100%",
        marginLeft: "auto",
        marginTop: 1,
        padding: 0
      }}
    >
      <ArcButton
        size="small"
        onClick={onClick}
        sx={{
          padding: "0 !important",
          color: "white",
          "&:hover": {
            backgroundColor: "grey.900",
            borderColor: "grey.500",
          },
          fontSize: "12px",
          fontWeight: 400,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textTransform: "none",
        }}
      >
        View all <ArrowForwardIcon sx={{ fontSize: 12, marginLeft: "4px" }} />
      </ArcButton>
    </ArcBox>
  );
};

export default ViewAllButton;
